import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	loading: false,
	permissionsLoadingComplete: false,
	timeStamp: false,
	error: null
};

const permissionsSlice = createSlice({
	name: 'permissions',
	initialState,
	reducers: {
		loadPermissions: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadPermissionsSuccess: (state, action) => {
			state.timeStamp = Date.now();
			state.loading = false;

			const orgID = action.payload.orgID;
			const { people, teams, devices, groups } = action.payload.data;

			const previous = state.data[orgID] || {
				people: [],
				teams: [],
				devices: [],
				groups: []
			};

			state.data[orgID] = {
				people: mergeReduxStateData(previous.people, people, 'personID'),
				teams: mergeReduxStateData(previous.teams, teams, 'teamID'),
				devices: mergeReduxStateData(previous.devices, devices, 'deviceID'),
				groups: mergeReduxStateData(previous.groups, groups, 'assetGroupID')
			};

			state.permissionsLoadingComplete = true;
		},
		loadPermissionsError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		grantPermission: (state) => {
			state.loadingAddPermission = true;
			state.error = null;
		},
		grantPermissionSuccess: (state) => {
			state.loadingAddPermission = false;
			state.error = null;
		},
		grantPermissionError: (state, action) => {
			state.loadingAddPermission = false;
			state.error = action.payload;
		},
		revokePermission: (state) => {
			state.loadingDeletePermission = true;
			state.error = null;
		},
		revokePermissionSuccess: (state) => {
			state.loadingDeletePermission = false;
			state.error = null;
		},
		revokePermissionError: (state, action) => {
			state.loadingDeletePermission = false;
			state.error = action.payload;
		},
		deletePermissionByIDs: (state) => {
			state.loadingDeletePermission = true;
			state.error = null;
		},
		deletePermissionByIDsSuccess: (state) => {
			state.loadingDeletePermission = false;
			state.error = null;
		},
		deletePermissionByIDsError: (state, action) => {
			state.loadingDeletePermission = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		// Handling the logout action, resetting permissions state
		builder.addCase('auth/logout', () => {
			return initialState;
		});
	}
});

export const permissionsActions = permissionsSlice.actions;

export default permissionsSlice.reducer;
